/**
 * 記事の編集画面ではカテゴリ名を、ウェブページの編集画面ではフォルダ名を取得できます。
 *
 * 使い方：
 * ```javascript
 * const categoryName = mtapp.getCategoryName({
 *    id: 1,
 *    field: 'label'
 * });
 * console.log(categoryName);
 * ```
 *
 * @param {Object} options - 設定オブジェクト
 * @param {Number} options.id - 調べたいカテゴリのID
 * @param {String} [options.field='label'] - 取得したいフィールド。'label' または 'basename'
 * @returns {String|undefined} カテゴリ名またはカテゴリの出力ファイル名。該当するカテゴリがない場合はundefined。
 */
export function getCategoryName(options) {
    // MT.App.categoryListの存在確認
    if (!Array.isArray(window.MT.App.categoryList)) {
        return;
    }

    // デフォルトオプションとマージ
    const op = {
        id: -1,
        field: 'label',
        ...options
    };

    // idのバリデーション
    if (op.id === -1 || !Number.isInteger(op.id)) {
        return;
    }

    // カテゴリリストから該当のカテゴリを探す
    for (const category of window.MT.App.categoryList) {
        if (parseInt(category.id) === op.id) {
            return category[op.field];
        }
    }
}
